module.exports = __webpack_public_path__ + "img/dd-dice-3.4e231741.png";